//@ts-ignore
import React, { memo, useRef } from 'react';
import ReactPlayer from 'react-player';

const IframeStyledHOC = ({ onLoad, ...rest }: any) => {
  const playerRef = useRef<any>();

  const getPlayerInstanceAndTryToPlay = () => {
    try {
      if (rest.autoplay) {
        // youtube autoplay fix
        const ytPlayer = playerRef.current?.getInternalPlayer();
        if (typeof ytPlayer?.playVideo === 'function') {
          ytPlayer?.playVideo();
        }
      }
      onLoad();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    /*@ts-ignore*/
    <ReactPlayer
      width="100%"
      height="100%"
      controls
      url={rest.url}
      onReady={getPlayerInstanceAndTryToPlay}
      playing={rest.autoplay}
      muted={rest.mute}
      ref={playerRef}
    />
  );
};

export default memo(IframeStyledHOC);
